<app-header [active]="3" [circuito]="circuito"></app-header>
<br>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="font-size: 16px">
          Vincular TV
          <span *ngIf="screensInUse !== null && maxScreens !== null" class="screen-counter" style="font-size: 13px; color: #666; margin-left: 8px;">Pantallas {{screensInUse}}/{{maxScreens}}</span>
        </div>
        <div class="card-body">
          <p style="margin:0 0 12px;color:#666;font-size:13px;">Ingresá el código de 6 caracteres que muestra el TV. El código distingue mayúsculas y minúsculas.</p>
          <div *ngIf="quotaAtCap" class="screen-cap-notice alert alert-warning" style="font-size: 13px;">Has alcanzado el límite de pantallas de tu plan ({{screensInUse}}/{{maxScreens}}). Solo podés vincular equipos existentes; para equipos nuevos, liberá una pantalla o <a routerLink="/pago">Mejorar plan</a>.</div>
          <div class="form-group row">
            <label class="col-3 col-form-label" for="claim-code">Código del TV</label>
            <div class="col-9">
              <input id="claim-code" type="text" class="form-control" [(ngModel)]="claimCode"
                     placeholder="Código del TV" autocomplete="off"
                     style="font-family: monospace; letter-spacing: 2px;">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-3 col-form-label">Destino</label>
            <div class="col-9">
              <div class="btn-group" role="group">
                <button type="button" class="btn" [class.btn-primary]="!useNewEquipo" [class.btn-outline-dark]="useNewEquipo"
                        (click)="useNewEquipo = false">Equipo existente</button>
                <button type="button" class="btn" [class.btn-primary]="useNewEquipo" [class.btn-outline-dark]="!useNewEquipo"
                        (click)="useNewEquipo = true">Equipo nuevo</button>
              </div>
            </div>
          </div>
          <div class="form-group row" *ngIf="!useNewEquipo">
            <label class="col-3 col-form-label" for="claim-equipo">Equipo</label>
            <div class="col-9">
              <select id="claim-equipo" class="form-control" [(ngModel)]="selectedEquipo">
                <option [ngValue]="null" disabled>Seleccioná un equipo</option>
                <option *ngFor="let equipo of equipos" [ngValue]="equipo">{{equipo.nombre}}<span *ngIf="grupoName(equipo)"> · {{grupoName(equipo)}}</span></option>
              </select>
            </div>
          </div>
          <div *ngIf="useNewEquipo">
            <div class="form-group row">
              <label class="col-3 col-form-label" for="claim-grupo">Grupo</label>
              <div class="col-9">
                <select id="claim-grupo" class="form-control" [(ngModel)]="selectedGrupo">
                  <option [ngValue]="null" disabled>Seleccioná un grupo</option>
                  <option *ngFor="let grupo of grupos" [ngValue]="grupo">{{grupo.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label" for="claim-nombre">Nombre</label>
              <div class="col-9">
                <input id="claim-nombre" type="text" class="form-control" [(ngModel)]="newEquipoName"
                       placeholder="Nombre del equipo nuevo">
              </div>
            </div>
          </div>
          <div *ngIf="errorMessage" class="alert alert-danger" style="font-size: 13px;">{{errorMessage}} <a *ngIf="showPagoCta" routerLink="/pago" style="text-decoration: underline; margin-left: 8px;">Mejorar plan</a></div>
          <div *ngIf="approved" class="alert alert-success" style="font-size: 13px;">TV vinculado correctamente. El equipo va a configurarse solo.</div>
          <div style="text-align: center">
            <button class="btn btn-primary" [disabled]="!canApprove()" (click)="approve()">Vincular</button>
          </div>
        </div>
      </div>
      <br>
    </div>
  </div>
  <div style="height: 50px; width: 100%"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/setting/vincular-tv/vincular-tv.component.html